import type { LigneMouvement, Mouvement } from '@mairistem/comptabilite';
import BasePanel from './BasePanel';

class LignePanel extends BasePanel {
	// Propriété qui sert à savoir si le bloc affecte le mouvement ou les lignes
	isOnlyMouvement = false;

	/**
	 * Le bloc est complet quand chaque ligne renseigne tous les `champs` passés.
	 * Helper de complétude pour les blocs « ligne » multi-champs : à utiliser
	 * dans `isComplete` pour exiger l'intégralité des champs dès que le bloc est
	 * obligatoire.
	 * @param data Le mouvement en cours de saisie
	 * @param champs Les champs de la ligne effectivement requis par le bloc
	 */
	protected everyLigneHas = (
		data: Mouvement,
		...champs: Array<keyof LigneMouvement>
	): boolean =>
		(data?.lignes ?? []).every((ligne) =>
			this.allPresent(...champs.map((champ) => ligne[champ])),
		);
}

export default LignePanel;
